// TES-1150 — what the "Inväntar abonnemangsaktivering" page shows, kept free
// of React and of runtime imports so it can be unit-tested with plain
// `node --test`.
import type {
  AwaitingActivationRow,
  PatientGroup,
} from "@care-by-ella/contracts";

export const AWAITING_ACTIVATION_PATIENT_GROUP_LABEL: Record<
  PatientGroup,
  string
> = {
  NEW_TREATMENT: "Ny behandling",
  PRESCRIPTION_TRANSFER: "Receptövertag",
};

// Plans by their stored key (contracts SUBSCRIPTION_PLAN_LABEL's words),
// restated here to keep this file free of runtime imports.
const PLAN_LABEL: Record<string, string> = {
  ella_uppstart: "Ella Uppstart",
  ella_underhall: "Ella Underhåll",
};

const PRESCRIPTION_LABEL: Record<string, string> = {
  new_issued: "Nytt recept",
  existing_valid: "Befintligt recept gäller",
};

/**
 * The activation status in words. Trialing counts as activated, like every
 * other entitlement gate (TES-591, Ö-370's default): such a row is one the
 * release is about to clear, never "medically incomplete".
 */
export function activationStatusLabel(status: string): string {
  switch (status) {
    case "trialing":
    case "active":
      return "Aktiverat";
    case "incomplete":
      return "Påbörjat, inte betalt";
    case "past_due":
    case "unpaid":
      return "Betalning misslyckades";
    case "canceled":
    case "incomplete_expired":
      return "Avbrutet";
    default:
      return "Inte aktiverat";
  }
}

function day(iso: string | null): string {
  return iso ? iso.slice(0, 10) : "–";
}

export function awaitingActivationViewRow(r: AwaitingActivationRow) {
  return {
    patientId: r.patientId,
    name: r.patientName,
    group: AWAITING_ACTIVATION_PATIENT_GROUP_LABEL[r.patientGroup],
    decided: day(r.decidedAt),
    prescribed: day(r.prescriptionRegisteredAt),
    prescription: r.prescriptionChoice
      ? (PRESCRIPTION_LABEL[r.prescriptionChoice] ?? "–")
      : "–",
    plan: r.plan ? (PLAN_LABEL[r.plan] ?? r.plan) : "–",
    activation: activationStatusLabel(r.subscriptionStatus),
    lastReminder: day(r.lastReminderAt),
  };
}
